export const MAILER_URL = process.env.REACT_APP_MAILER_URL;
export const WHATSAPP_URL = process.env.REACT_APP_WHATSAPP_URL;